import { merchantKnowledgeArticleSchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Edits the demo article in place, or publishes one the first time. */
export const upsertDemoKnowledgeArticle = {
  name: "upsertDemoKnowledgeArticle" as const,
  input: z
    .object({
      id: merchantKnowledgeIdFormat.schema.nullable(),
      title: z.string(),
      content: z.string(),
    })
    .strict(),
  output: merchantKnowledgeArticleSchema,
};
